/**
 * Sherpath AI Chat Sidebar iframe message event types
 */
export enum SherpathAIIframeMessageType {
  /**
   * Sent from iframe to app when a link is clicked
   */
  SHERPATH_AI_LINK_CLICK = 'SHERPATH_AI_LINK_CLICK',

  /**
   * Sent from app to iframe when page context is updated
   */
  SHERPATH_AI_PAGE_CONTEXT_UPDATE = 'SHERPATH_AI_PAGE_CONTEXT_UPDATE',

  /**
   * Sent from iframe to app when iframe is ready to receive messages
   */
  SHERPATH_AI_IFRAME_READY = 'SHERPATH_AI_IFRAME_READY'
}

/**
 * NACS entry context types used when launching the Sherpath AI chat from a PLP.
 * NACS keeps the Spark wire value as 'CKSA' (CK Assessment launcher compatibility).
 */
export enum SherpathAIContextType {
  PLP = 'PLP',
  SPARK = 'CKSA'
}

/**
 * Sherpath AI iframe origin URL for postMessage security
 * This is the production URL for the NHE AI application
 */
export const SHERPATH_AI_ORIGIN = 'https://nhe-ai.elsevier.com';

/**
 * Allowed origins for incoming postMessage events in production.
 * Messages from these origins are considered trusted and will be processed.
 *
 * Supports two formats:
 * 1. Exact origin match: 'https://www.osmosis.org'
 * 2. Domain suffix match: '.elsevier.com' (matches any subdomain like nhe-ai.elsevier.com, example.elsevier.com, etc.)
 *
 * Examples:
 * - 'https://www.osmosis.org' matches only https://www.osmosis.org
 * - '.elsevier.com' matches https://nhe-ai.elsevier.com, https://example.elsevier.com, https://elsevier.com, etc.
 */
export const ALLOWED_MESSAGE_ORIGINS = [
  '.osmosis.org',
  '.elsevier.com',
  '.vitalsource.com'
];
